<template>
  <div class="banner-container">
    <BannerImage
      v-for="(item, index) in bannerListData"
      :key="index"
      :bannerData="item"
      :bannerType="bannerType"
      :isMultBrow="isMultBrow"
      :banner-index="index"
      @click="eEmitClick(item)"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import BannerImage from '../banner-image.vue';
import { BannerConfig, BannerType } from '../../types';

@Component({
  components: {
    BannerImage,
  },
})
export default class Tile extends Vue {
  /** banner数据 */
  @Prop({ default: [] }) bannerListData!: BannerConfig[];
  /** 是否支持重复曝光上报 */
  @Prop({ default: true }) isMultBrow!: Boolean;

  /** 在template中使用 */
  bannerType = BannerType.tile;

  /** 往外抛事件 */
  @Emit('click')
  eEmitClick(item: BannerConfig) {
    return item;
  }
}
</script>

<style scoped lang="less">
@import (reference) url(../../less/index.less);
.banner-container {
  width: 686 / @rem;
  display: flex;
  justify-items: center;
  flex-direction: column;
  align-items: center;
  /deep/ .banner-image {
    width: 100%;
    margin-bottom: 20 / @rem;
  }
}
</style>
